<template>
    <product-card-layout-mobile
        :is-add-on="isAddOn"
        :thumb="product.info.imageUrl"
        :name="product.info.name"
        :product-link="productLink"
        :offers-count="product.offers && product.offers.length"
        :is-recommended="product.recommended"
        :_expanded-count="expanded"
        :_expanded-limit="expandedLimit"
        @change-expanded-count="expanded = $event"
        @change-expanded-limit="expandedLimit = $event"
    >
        <div class="d-flex flex-column my-2">
            <supplier-name-label v-if="isTO1" :supplier-name="product.info.supplierName" />
            <div v-if="product.info.description" class="short-description my-1">
                {{ product.info.description }}
            </div>
            <transfer-operated-by-label :product="product" class="mb-2" />
            <transfer-driver-languages :lang-codes="langCodes" />
            <v-divider class="my-3" />
        </div>
        <template v-slot:price>
            <slot name="price" :offer="minPriceOffer" :offer-key="minPriceOffer.offerKey">
                <div v-if="!minPriceOffer.soldOut && !hidePrice">
                    <nuxt-link v-if="!isAddOn" no-prefetch :to="productLink" class="text-h6 text-decoration-none">
                        <strong data-cy="client-price" class="text-black">
                            {{ $t('from') }} {{ $filters.price(minPriceOffer.price) }}
                        </strong>
                    </nuxt-link>
                    <span v-else class="text-h6 text-decoration-none">
                        <strong data-cy="client-price" class="text-black">
                            {{ $t('from') }} {{ $filters.price(minPriceOffer.price) }}
                        </strong>
                    </span>
                    <discount-label :price="minPriceOffer.price" />
                    <commission-amount :commission="minPriceOffer.price.commission" />
                </div>
            </slot>
        </template>
        <template v-slot:offers>
            <transfer-offer-card
                v-for="(offer, offerIndex) in product.offers.slice(0, expanded)"
                :key="offerIndex"
                :offer="offer"
                :full-card="false"
                :data-cy="`transfer-offer-card-${offerIndex}`"
            >
                <template v-slot:price>
                    <slot name="price" :offer="offer" :offer-key="offer.offerKey" />
                </template>
            </transfer-offer-card>
        </template>
    </product-card-layout-mobile>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {TransferCard} from '~src/components/transfers/search/offers/transferCard.src'
    import TransferOfferCard from '~src/components/transfers/info/transferOfferCard.src'
    import DiscountLabel from '~src/components/snippets/discountLabel.src'
    import CommissionAmount from '~/components/snippets/CommissionAmount.vue'
    import TransferDriverLanguages from '@/components/snippets/TransferDriverLanguages.vue'
    import ProductCardLayoutMobile from '@/components/search/ProductCardLayoutMobile.vue'

    @Component({
        components: {
            ProductCardLayoutMobile,
            TransferDriverLanguages,
            DiscountLabel,
            CommissionAmount,
            TransferOfferCard,
        },
    })
    export class TransferCardMobile extends TransferCard {
        open() {
            if (!this.expanded || this.expanded >= this.product.offers.length) {
                this.toggleOffers()
            } else {
                this.showAllOffers()
            }
        }

        showAllOffers() {
            this.expanded = this.product.offers.length
        }
    }

    export default TransferCardMobile
</script>

<style scoped lang="scss">
    .v-card__title {
        background: rgba(0, 0, 0, 0.5);

        a {
            color: #ffffff;
            text-decoration: none;
        }
    }
</style>
